import * as React from "react";
import type { SVGProps } from "react";
const SvgFlipRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.046 4.8 21.6 9.416m0 0-4.554 4.615M21.6 9.415H6.4a4 4 0 0 0-4 4V15.2a4 4 0 0 0 4 4H12"
    />
  </svg>
);
export default SvgFlipRight;
